import { css } from '@emotion/react';

export const LinkMixin = css`
  --focus-spread: 2px;
  cursor: pointer;
  padding: var(--a-link-padding);
`;
